import { Profile } from "../PlatFormsLayout/Profile";
import { LI, UL } from "../../AbstractElements";
import Language from "./Langauge";

const HeaderContain = () => {
  return (
    <div className="nav-right pull-right right-header p-0 dash-76">
      <UL
        attrUL={{
          className: `simple-list  d-flex flex-row align-items-center gap-3 nav-menus`,
        }}
      >
        <LI attrLI={{ className: "onhover-dropdown" }}>
          <Language />
        </LI>

        <Profile />
      </UL>
    </div>
  );
};
export default HeaderContain;
